import { render, staticRenderFns } from "./ConfigViewerAddressList.vue?vue&type=template&id=98fad93c"
import script from "./ConfigViewerAddressList.vue?vue&type=script&lang=js"
export * from "./ConfigViewerAddressList.vue?vue&type=script&lang=js"
import style0 from "./ConfigViewerAddressList.vue?vue&type=style&index=0&id=98fad93c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports